const CALL_REQUEST_EVENT = "pilcore:zadarma-call-request";
const HANGUP_REQUEST_EVENT = "pilcore:zadarma-hangup-request";
const STATE_EVENT = "pilcore:zadarma-state";

const DEFAULT_STATE = {
  enabled: false,
  ready: false,
  active: false,
  status: "idle",
  message: "",
  error: "",
  call: null,
};

function getWindowState() {
  if (typeof window === "undefined") return DEFAULT_STATE;
  return window.__pilcoreZadarmaTelephonyState || DEFAULT_STATE;
}

export function getZadarmaTelephonyState() {
  return getWindowState();
}

export function subscribeZadarmaTelephony(listener) {
  if (typeof window === "undefined" || typeof listener !== "function") {
    return () => {};
  }

  const handleState = (event) => {
    listener(event.detail || getWindowState());
  };

  window.addEventListener(STATE_EVENT, handleState);
  listener(getWindowState());

  return () => {
    window.removeEventListener(STATE_EVENT, handleState);
  };
}

export function requestZadarmaCall(payload) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CALL_REQUEST_EVENT, { detail: payload || {} }));
}

export function requestZadarmaHangup() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(HANGUP_REQUEST_EVENT));
}

export function normalizeCallableNumber(value) {
  const text = String(value || "").trim();
  if (!text) return "";

  let normalized = text
    .replace(/\b(ext|extension|extensión|extension)\b\.?\s*\d+$/i, "")
    .replace(/[^\d+]/g, "");

  if (normalized.startsWith("00")) {
    normalized = `+${normalized.slice(2)}`;
  }

  if (normalized.indexOf("+") > 0) {
    normalized = normalized.replace(/\+/g, "");
  } else if (normalized.startsWith("+")) {
    normalized = `+${normalized.slice(1).replace(/\+/g, "")}`;
  }

  const digitCount = normalized.replace(/\D/g, "").length;
  return digitCount >= 3 ? normalized : "";
}

export function extractPhoneOptions(value) {
  const rawValues = Array.isArray(value) ? value : [value];
  const seen = new Set();

  return rawValues
    .flatMap((item) =>
      String(item || "")
        .split(/[\n,;|/]+/)
        .map((part) => part.trim())
    )
    .map((label) => {
      const number = normalizeCallableNumber(label);
      return number ? { label: label || number, number } : null;
    })
    .filter(Boolean)
    .filter((option) => {
      const key = option.number;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}

export const zadarmaTelephonyEvents = {
  CALL_REQUEST_EVENT,
  HANGUP_REQUEST_EVENT,
  STATE_EVENT,
};
